module.exports = __webpack_public_path__ + "images/501ca67.png";